import axios from "axios";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

/**
 * Collection-level review of generated test cases.
 *
 * The overview is cheap and computed from the stored cases, so it loads with the page. The AI pass
 * costs a model call of some seconds and is only run when someone asks for it.
 */

const fetchReviewOverview = async ({ queryKey }) => {
  const [, collectionId, companyId] = queryKey;
  const response = await axios.get(
    `${API_BACKEND_URL}/testcase/review/collection?collectionId=${collectionId}&companyId=${companyId}`,
  );
  return response.data;
};

export const useTestCaseReview = (collectionId, companyId, options = {}) =>
  useQuery({
    queryKey: ["testCaseReview", collectionId, companyId],
    queryFn: fetchReviewOverview,
    enabled: Boolean(collectionId && companyId),
    ...options,
  });

export const useRunTestCaseReview = (collectionId, companyId, options = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const response = await axios.post(
        `${API_BACKEND_URL}/testcase/review/collection/analyze`
          + `?collectionId=${collectionId}&companyId=${companyId}`,
      );
      return response.data;
    },
    onSuccess: (data) => {
      // Seed the cache with the response so the panel updates without a second round trip.
      queryClient.setQueryData(["testCaseReview", collectionId, companyId], data);
      options.onSuccess?.(data);
    },
    ...options,
  });
};
